import React from "react";
import SlideOver from "../../components/ui/SlideOver";
import PasscodeGeneration from "../../component/AssetManagement/PasscodeGeneration";

/**
 * Wraps the existing PasscodeGeneration screen in a slide-over so it's
 * reachable from the asset list (page-header button + selection bar)
 * without taking the user to a separate page. preselectedAssetIds is
 * advisory until PasscodeGeneration is extended to read it.
 */
// eslint-disable-next-line no-unused-vars
export default function BulkPasscodeSlideOver({open, onClose, preselectedAssetIds}) {
  return (
    <SlideOver
      open={open}
      onOpenChange={(o) => !o && onClose && onClose()}
      title="Generate passcodes"
      subtitle="Create one-time unlock codes for Bluetooth locks."
      size="xl"
    >
      <SlideOver.Body className="p-0">
        <div className="px-2 sm:px-4 py-4 legacy-in-slideover">
          <PasscodeGeneration />
        </div>
      </SlideOver.Body>
    </SlideOver>
  );
}
